var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSocial3(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 11.64C0 4.95169 5.24004 0 12 0C18.76 0 24 4.95169 24 11.64C24 18.3284 18.76 23.28 12 23.28C10.7858 23.28 9.62088 23.1197 8.52636 22.8188C8.3136 22.7602 8.08735 22.7768 7.88544 22.8658L5.50361 23.9172C4.88057 24.1923 4.17727 23.7492 4.15639 23.0684L4.09104 20.9338C4.083 20.6708 3.96468 20.425 3.76867 20.2496C1.43376 18.1615 0 15.1385 0 11.64ZM8.31905 9.4516L4.79405 15.0441C4.45577 15.5808 5.11548 16.1856 5.62085 15.8021L9.40728 12.9284C9.66341 12.734 10.0174 12.733 10.2746 12.9259L13.0783 15.0287C13.9195 15.6597 15.1202 15.4381 15.681 14.5485L19.206 8.95595C19.5442 8.41924 18.8845 7.81444 18.3791 8.19796L14.5927 11.0716C14.3366 11.266 13.9826 11.267 13.7254 11.0741L10.9218 8.97136C10.0805 8.3404 8.87976 8.56192 8.31905 9.4516Z",
    fill: "#FFDD81"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocial3);
export default __webpack_public_path__ + "static/media/social-3.fd07cdb3661be0ca250814fdcd12c038.svg";
export { ForwardRef as ReactComponent };